<template>
<div>
    <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="發行單位:">
                    <el-radio-group v-model.number="addForm.type" @change="checkType">
                        <el-radio :label="1">公司</el-radio>
                        <el-radio :label="2">通路商</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="品牌:">
                    <el-radio-group v-model.number="addForm.brand_id" @change="checkInput">
                        <el-radio :label="1">N牌</el-radio>
                        <el-radio :label="2">S牌</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="10">
                <el-form-item label="禮卷名稱:">
                    <el-input v-model="addForm.name" style="width: 50%;"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="使用期限:">
                    <el-date-picker v-model="addForm.startdate" type="daterange" range-separator="到" start-placeholde="開始日期" end-placeholde="結束日期"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2" v-if="isType">
                <el-form-item label="會員:">
                    <el-tag color="#f9c6ba" effect="dark" style="color:red; border-color:red;">{{this.level0}}</el-tag>
                </el-form-item>
            </el-col>
            <el-col :lg="10" v-if="isType">
                <el-form-item label="折扣金:">
                    <el-input v-model.number="addForm.memberdiscount_0" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="會員:">
                    <el-tag color="#f9c6ba" effect="dark" style="color:red; border-color:red;">{{this.level1}}</el-tag>
                </el-form-item>
            </el-col>
            <el-col :lg="10">
                <el-form-item label="折扣金:">
                    <el-input v-model.number="addForm.memberdiscount_1" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="會員:">
                    <el-tag color="#f9c6ba" effect="dark" style="color:#494ca2;border-color:#f9c6ba;font-wi">{{this.level2}}</el-tag>
                </el-form-item>
            </el-col>
            <el-col :lg="10">
                <el-form-item label="折扣金:">
                    <el-input v-model.number="addForm.memberdiscount_2" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-button type="primary" @click="addCoupon">新增禮卷</el-button>
                <el-button type="default" @click="back">返回</el-button>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
    </el-form>

</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import moment from 'moment'
import {
    async
} from 'q'

export default {
    name: 'Add',
    data() {
        return {
            addForm: {
                brand_id: 1,
                name: '',
                type: null,
                startdate: [],
                memberdiscount_1: null,
                memberdiscount_2: null,
                memberdiscount_0: null,

            },
            level1: '',
            level2: '',
            level0: '',
            strStartDate: '',
            strEndDate: '',
            isType: false,
        }
    },
    computed: mapGetters(["getCouponError", "getCouponMsg"]),
    methods: {
        ...mapActions(["addCoupon"]),
        async addCoupon() {
            this.strStartDate = moment(this.addForm.startdate[0]).format("YYYY-MM-DD")
            this.strEndDate = moment(this.addForm.startdate[1]).format("YYYY-MM-DD")
            const data = {
                brand_id: this.addForm.brand_id,
                name: this.addForm.name,
                type: this.addForm.type,
                on_sale_start: this.strStartDate,
                on_sale_end: this.strEndDate,
                memberdiscount_1: this.addForm.memberdiscount_1,
                memberdiscount_2: this.addForm.memberdiscount_2,
                memberdiscount_0: this.addForm.memberdiscount_0,
            }
            await this.$store.dispatch('addCoupon', data)
            if (this.getCouponError == true) {
                this.$notify({
                    title: '失敗',
                    message: this.getCouponMsg,
                    type: 'error',
                    duration: '4500',
                    position: 'top-right'
                });
            } else {
                this.$emit('back')
                this.$notify({
                    title: '成功',
                    message: '新增禮卷成功',
                    type: 'success',
                    duration: '4500',
                    position: 'top-right'
                });

            }
        },
        checkInput() {
            if (this.addForm.brand_id == 1) {

                this.level1 = '白金'
                this.level2 = '尊爵'
            } else if (this.addForm.brand_id == 2) {
                this.level1 = '芙蓉'
                this.level2 = '金鑽'
            }
        },
        checkType() {
            if (this.addForm.type == 2) {
                this.level0 = '非會員'
                this.isType = true
            } else {
                this.level10 = '',
                    this.isType = false
            }
        },

        back() {
            this.$emit('back')
        }
    },
    created() {
        this.checkInput()
    }
}
</script>

<style lang="scss" scoped>
.el-row {
    margin-bottom: 20px;
    font-weight: bold;
}
</style>
